
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class TopToolBarPaginator extends Vue {
  @Prop({ required: true, default: 0 })
  totalItems: number

  @Prop({ required: true, default: 20 })
  pageSize: number

  @Prop({ required: false, default: false })
  isCursorBased: number

  @Prop({ required: false, default: () => [] })
  pageSizes: number[]

  @Prop({ required: false })
  name: string

  currentPage = 1
  totalPages = 1
  pageSizeSelect: number = NaN

  created () {
    this.pageSizeSelect = this.pageSize
    this.calculatePageNumbers()
  }

  @Watch('totalItems')
  watchTotalItems () {
    this.calculatePageNumbers()
  }

  isVisble (page: number) {
    return page === this.currentPage ||
    (page > 1 && page === this.currentPage - 1) ||
    (page <= this.totalPages && page === this.currentPage + 1) ||
    (page === 1 && this.currentPage === 2) ||
    (!this.isCursorBased && page === 3 && this.currentPage === 1) ||
    (this.currentPage === this.totalPages && this.currentPage - 2 > 0 && page === this.currentPage - 2)
  }

  calculatePageNumbers () {
    this.currentPage = 1
    this.totalPages = Math.ceil(this.totalItems / this.pageSizeSelect)
  }

  selectSize () {
    this.calculatePageNumbers()
    this.$emit('sizeChange', this.pageSizeSelect)
  }

  selectPage (page: number) {
    if (page !== this.currentPage && page > 0 && page <= this.totalPages) {
      this.currentPage = page
      this.$emit('pageChange', page)
    }
  }
}
